/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { getDelegatedSessions, getOversightUsersById } from '@/api/oversight';
import { DelegatedSessions, OversightUsers } from '@/api/oversight/types';
import { Search } from '@/components/Search';
import Snackbar from '@/components/Snackbar';
import {
  IconAdminPanelSettingsMS,
  IconArrowCircleLeftMS,
  IconArrowForwardIosMS,
  IconPageviewMS,
} from '@/constants/icons';
import { GlobalContext } from '@/context/global';
import useErrorMessage from '@/hooks/useErrorMessage';
import useSnackbar from '@/hooks/useSnackbar';
import { formatDate } from '@/pages/Oversight/utils';
import { Search as SearchIcon } from '@mui/icons-material';
import { useCallback, useContext, useEffect, useState } from 'react';
import { useDefaultLayout } from 'react-resizable-panels';
import { useNavigate, useParams } from 'react-router-dom';

import { Button } from '../../../components/Button';
import { Card, CardData } from '../../../components/Card';
import { Table } from '../../../components/Table';
import {
  StyledTableCellBody,
  SubtitleCell,
} from '../../../components/Table/styles';
import { TabsPanel } from '../../../components/TabsPanel';
import { TabItem } from '../../../components/TabsPanel/types';
import {
  BackButton,
  CardContainer,
  GridMainContainer,
  RoundedGreen,
  Section,
  StyledTitle,
} from '../../../styles';
import {
  delegatedAccessAdmUser,
  delegatedAccessRow,
  infoADMUser,
  infoClient,
  infoCompany,
  sectionAdmUser,
  sectionAdmUserRow,
} from '../../Clients/CustomerDetails/data';
import {
  ContainerGroup,
  Panel,
  StyledSeparator,
} from '../../Clients/CustomerDetails/styles';
import { AmountOFClients, TableDataName } from '../../Clients/styles';

export function Details(): JSX.Element {
  const [loading, setLoading] = useState(true);
  const [isShowDrawer, setIsShowDrawer] = useState(false);
  const [, setSearch] = useState('');
  const [tabs, setTabs] = useState<TabItem[]>([]);
  const [selectedTab, setSelectedTab] = useState<string>('');
  const [userData, setUserData] = useState<OversightUsers>();
  const [cardData, setCardData] = useState<CardData[]>([
    { label: 'Nome', value: '' },
    { label: 'Status do usuário', value: false, user_status: 'active' },
    { label: 'ID', value: 0 },
    { label: 'Tipo de usuário', value: '' },
    { label: 'Última atividade', value: '' },
    { label: 'E-mail', value: '' },
    { label: 'CPF', value: '***.***.***-**' },
  ]);
  const [delegatedSessions, setDelegatedSessions] = useState<
    DelegatedSessions[]
  >([]);
  const [delegatedRecords, setDelegatedRecords] = useState(0);
  const [sessionsRecords, setSessionsRecords] = useState(0);
  const [page, setPage] = useState(0);

  const MAX_TABS = 2;

  const { defaultLayout, onLayoutChanged } = useDefaultLayout({
    id: 'unique-layout-id',
    panelIds: isShowDrawer ? ['left', 'right'] : ['left'],
  });

  const { id } = useParams();
  const { flag } = useParams();
  const navigate = useNavigate();
  const { handleSnackbar } = useSnackbar();
  const { openSnackbar } = useContext(GlobalContext);
  const { getErrorMessage } = useErrorMessage();

  const isADMUsers = flag?.includes('administrative');
  const titlePage = flag?.includes('administrative')
    ? 'Usuários Administrativos'
    : 'Clientes';

  const handleOpenActivityDelegatedAccess = (
    row: typeof delegatedAccessAdmUser[0]
  ): void => {
    setIsShowDrawer(true);

    const hasSessionTab = tabs.some((tab) => tab.source === 'section_adm_user');
    if (hasSessionTab) return;

    const existingTab = tabs.find((tab) => tab.source === 'delegated_access');
    if (existingTab) {
      const newTab: TabItem = {
        id: row.id,
        value: existingTab.value,
        title: 'Acessos delegados',
        subtitle: row.name,
        source: 'delegated_access',
      };
      setTabs((prev) =>
        prev.map((tab) => (tab.source === 'delegated_access' ? newTab : tab))
      );
      setSelectedTab(existingTab.value);
      return;
    }

    if (tabs.length >= MAX_TABS) return;

    const newTab: TabItem = {
      id: row.id,
      value: crypto.randomUUID(),
      title: 'Acessos delegados',
      subtitle: row.name,
      source: 'delegated_access',
    };
    setTabs((prev) => [...prev, newTab]);
    setSelectedTab(newTab.value);
  };

  const handleOpenActivitySectionUser = (
    row: typeof sectionAdmUser[0]
  ): void => {
    setIsShowDrawer(true);

    const existingTab = tabs.find((tab) => tab.source === 'section_adm_user');
    if (existingTab) {
      if (existingTab.id === row.id) {
        setSelectedTab(existingTab.value);
        return;
      }

      // clicou em outro, fecha tudo e abre só a nova
      const newTab: TabItem = {
        id: row.id,
        value: crypto.randomUUID(),
        title: 'Sessões do usuário administrador',
        subtitle: infoADMUser[0].value.toString(),
        source: 'section_adm_user',
      };
      setTabs([newTab]);
      setSelectedTab(newTab.value);
      return;
    }

    const newTab: TabItem = {
      id: row.id,
      value: crypto.randomUUID(),
      title: 'Sessões do usuário administrador',
      subtitle: infoADMUser[0].value.toString(),
      source: 'section_adm_user',
    };
    setTabs((prev) => [...prev, newTab]);
    setSelectedTab(newTab.value);
  };

  const handleActivityClick = (id: number): void => {
    if (tabs.length >= MAX_TABS) return;

    const newTab: TabItem = {
      id,
      value: crypto.randomUUID(),
      title: 'Acesso Delegado',
      subtitle: 'João da Silva',
      source: 'delegated_access',
    };
    setTabs((prev) => [...prev, newTab]);
    setSelectedTab(newTab.value);
  };

  const handleClose = (value: string): void => {
    const updated = tabs.filter((tab) => tab.value !== value);
    setTabs(updated);
    if (updated.length === 0) {
      setIsShowDrawer(false);
    }
  };

  const handleCloseAll = (): void => {
    setTabs([]);
    setIsShowDrawer(false);
  };

  const getUserById = useCallback(async () => {
    try {
      const { data } = await getOversightUsersById(Number(id));

      setUserData(data);
      const status = data.is_active ? 'active' : ('inactive' as const);

      setCardData([
        { label: 'Nome', value: data.name },
        {
          label: 'Status do usuário',
          value: data.is_active,
          user_status: status,
        },
        { label: 'ID', value: data.id },
        { label: 'Tipo de usuário', value: data.role },
        {
          label: 'Última atividade',
          value: formatDate('2026-06-01T16:29:29.570Z', 'relative'),
        },
        { label: 'E-mail', value: data.email },
        { label: 'CPF', value: '***.***.***-**' },
      ]);
    } catch (error) {
      handleSnackbar(getErrorMessage(error), true);
    }
  }, []);

  const getDelegatedAccess = useCallback(async () => {
    try {
      const { data } = await getDelegatedSessions();

      setDelegatedSessions(data.delegated_sessions);
    } catch (error) {
      handleSnackbar(getErrorMessage(error), true);
    }
  }, [getErrorMessage, handleSnackbar]);

  useEffect(() => {
    getUserById();
    getDelegatedAccess();

    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <ContainerGroup
      orientation="horizontal"
      defaultLayout={defaultLayout}
      onLayoutChanged={onLayoutChanged}
    >
      <Panel minSize="65%">
        <GridMainContainer>
          <BackButton onClick={() => navigate(-1)}>
            {IconArrowCircleLeftMS}
          </BackButton>

          <StyledTitle>
            <>
              {IconAdminPanelSettingsMS} PROTO OVERSIGHT
              <span>
                {IconArrowForwardIosMS} {titlePage} {IconArrowForwardIosMS}{' '}
                {userData?.name}
              </span>
            </>
          </StyledTitle>

          <CardContainer>
            <Card
              title="Informações do usuário"
              cardData={isADMUsers ? cardData : infoClient}
              isLoading={loading}
              qtdItems={isADMUsers ? 7 : 6}
            />
            {!isADMUsers && (
              <Card
                title="Informações da conta"
                cardData={infoCompany}
                isLoading={loading}
              />
            )}
          </CardContainer>

          <Section>
            <div className="values">
              <TableDataName>Acessos delegados</TableDataName>

              <AmountOFClients>
                {delegatedAccessAdmUser.length} registros
              </AmountOFClients>
            </div>

            <Search
              setSearchField={setSearch}
              placeholder="Busca por cliente, motivo ou status..."
              width="423px"
              withoutBorder
            />
          </Section>

          <Table
            data={delegatedAccessAdmUser}
            tableHeadData={delegatedAccessRow}
            getRowId={(row) => row.id}
            emptyTableDescription="Nenhum resultado encontrado"
            emptyTableIcon={<SearchIcon />}
            records={delegatedRecords}
            page={page}
            setPage={setPage}
            renderRow={(row) => (
              <>
                <StyledTableCellBody>{row.name}</StyledTableCellBody>
                <StyledTableCellBody>
                  {row.status.includes('ativa') ? (
                    <div>
                      <RoundedGreen />
                      {row.status}
                    </div>
                  ) : (
                    <>
                      {row.status}
                      <SubtitleCell>{row.finish_section}</SubtitleCell>
                    </>
                  )}
                </StyledTableCellBody>
                <StyledTableCellBody>{row.reason}</StyledTableCellBody>
                <StyledTableCellBody>
                  <Button
                    variant="outlined"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleOpenActivityDelegatedAccess(row);
                    }}
                  >
                    Ver atividade (4)
                    {IconPageviewMS}
                  </Button>
                </StyledTableCellBody>
              </>
            )}
          />

          <Section>
            <div className="values">
              <TableDataName>Sessões do usuário administrativo</TableDataName>

              <AmountOFClients>{sectionAdmUser.length} sessões</AmountOFClients>
            </div>

            <Search
              setSearchField={setSearch}
              placeholder="Busca por status ou erro..."
              width="423px"
              withoutBorder
            />
          </Section>

          <Table
            data={sectionAdmUser}
            tableHeadData={sectionAdmUserRow}
            getRowId={(row) => row.id}
            onRowClick={(row) => row.id}
            emptyTableDescription="Nenhum resultado encontrado"
            emptyTableIcon={<SearchIcon />}
            records={sessionsRecords}
            page={page}
            setPage={setPage}
            renderRow={(row) => (
              <>
                <StyledTableCellBody>{row.starts_section}</StyledTableCellBody>
                <StyledTableCellBody>
                  {row.status === 'Online' ? (
                    <div>
                      <RoundedGreen />
                      {row.status}
                    </div>
                  ) : (
                    <>
                      {row.status}
                      <SubtitleCell>{row.finish_section}</SubtitleCell>
                    </>
                  )}
                </StyledTableCellBody>
                <StyledTableCellBody>
                  {row.delegated_access ?? '-'}
                </StyledTableCellBody>
                <StyledTableCellBody>
                  <Button
                    variant="outlined"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleOpenActivitySectionUser(row);
                    }}
                  >
                    Ver atividade (4)
                    {IconPageviewMS}
                  </Button>
                </StyledTableCellBody>
              </>
            )}
          />
        </GridMainContainer>
      </Panel>
      <StyledSeparator className="resize-handle" />
      {isShowDrawer && (
        <Panel>
          <TabsPanel
            tabs={tabs}
            selectedTab={selectedTab}
            onSelectedTabChange={setSelectedTab}
            onClose={handleClose}
            onCloseAll={handleCloseAll}
            onActivityClick={handleActivityClick}
          />
        </Panel>
      )}
      {openSnackbar && <Snackbar />}
    </ContainerGroup>
  );
}
